import { makeTypes, mac, asyncMac, createReducer, reduceReducers } from 'ducks-maker'
import { createFetch, addHOR } from './hors.js'
import { leer, crear } from '../services/api'

const t = makeTypes('gruposcotizacion')
const FETCH = t('fetch').async()
const ADD = t('add').single()
 
const fetchActions = asyncMac(FETCH)
const addGrupoCotizacion = mac(ADD, 'payload')

const initialState = {
    data: [],
    fetched: false,
    fetching: false,
}

const fetchReducer = createReducer(initialState, createFetch( FETCH ))
const addReducer = createReducer(initialState, addHOR({ ADD }))

export default reduceReducers(fetchReducer, addReducer)

export const fetchGruposCotizacion = () => async (dispatch, getState) => {
    dispatch(fetchActions.start())
    try {
        const data = await leer('/grupo-cotizacion')
        dispatch(fetchActions.success(data))
    } catch (error) {
        dispatch(fetchActions.error(error))
    }
}

export const agregarGrupoCotizacion = values => async (dispatch, getState) => {
    dispatch(fetchActions.start())
    try {
        const data = await crear('/grupo-cotizacion', values)
        console.log(data)
        dispatch(addGrupoCotizacion(data))
    } catch (error) {
        dispatch(fetchActions.error(error))
    }
}